/**
 * @generated SignedSource<<5a1205f019623b0fbc57543646f42a92>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionEditFileFragment$data = {
  readonly dataset: {
    readonly slug: string;
  };
  readonly id: string;
  readonly version: Semver;
  readonly viewerCanCreateDatasetVersion: boolean;
  readonly " $fragmentType": "DatasetVersionEditFileFragment";
};
export type DatasetVersionEditFileFragment$key = {
  readonly " $data"?: DatasetVersionEditFileFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionEditFileFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionEditFileFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": "viewerCanCreateDatasetVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_DATASET_VERSION\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dataset",
      "kind": "LinkedField",
      "name": "dataset",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};

(node as any).hash = "d401f4375714fad811f607330d7a697f";

export default node;
